import styles from "../styles.module.css";
import BlockyHeavyText from "../../../../custom-texts/blocky-heavy-text.tsx";

interface Props {
  topText: string | number,
  bottomText: string,
  topTextColor?: string,
  maxWidth?: number,
  underline?: boolean,
}

const ContestInfoContainer = ({topText, bottomText, topTextColor, maxWidth, underline}: Props) => {
  const topStyle: React.CSSProperties = {
    ...(topTextColor && { color: topTextColor }),
    ...(maxWidth && {
      maxWidth,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap" as const,
    }),
    ...(underline && { textDecoration: "underline" }),
  };

  const bottomStyle: React.CSSProperties = {
    ...(underline && { textDecoration: "underline" }),
  };

  return (
    <div className={styles.centeredColumn} style={maxWidth ? { maxWidth } : undefined}>
      <BlockyHeavyText
        className={styles.topContainer}
        style={Object.keys(topStyle).length > 0 ? topStyle : undefined}
      >
        {topText}
      </BlockyHeavyText>
      <BlockyHeavyText className={styles.bottomContainer} style={Object.keys(bottomStyle).length > 0 ? bottomStyle : undefined}>
        {bottomText}
      </BlockyHeavyText>
    </div>
  )
}

export default ContestInfoContainer;